import React from "react";
import BaseGrid from "Components/Fragment/BaseGrid";
import SelectFilter from "./components/SelectFilter";
import InputTextSearch from "./components/InputTextSearch";
import { filterByParticipantCourses } from "../../services/filterService";
import ToggleButtonGroupViewType from "../ToggleButtonGroupViewType";
import * as CONSTANTS from "../../constants";
import { useFilter } from "./context";
import { useMyLearning } from "../../context";
import "../../style.css";

const TabFilter = ({ languageContext }) => {
  const filter = useFilter();
  const { courses, programs } = useMyLearning();
  const totalItems =
    (filterByParticipantCourses(courses)?.length || 0) +
    (filterByParticipantCourses(programs)?.length || 0);
  const displaySearch = totalItems > 6;
  return (
    <BaseGrid childWidth="auto">
      <SelectFilter
        name={languageContext("status")}
        options={CONSTANTS.SORT_OPTIONS_STATUS}
        value={filter.state.status.toLowerCase()}
        onChange={filter.setFilterStatus}
        languageContext={languageContext}
        className="filter-select"
        translateOptions={true}
      />
      <SelectFilter
        name={languageContext("sort")}
        options={CONSTANTS.SORT_OPTIONS_ORDER}
        value={filter.state.sortBy}
        onChange={filter.setSortBy}
        languageContext={languageContext}
        className="filter-select"
        translateOptions={true}
      />
      {displaySearch && (
        <InputTextSearch
          searchText={filter.state.searchText}
          setSearchText={filter.setSearchText}
          onSearch={filter.onSearch}
          languageContext={languageContext}
          sx={{ width: 150 }}
        />
      )}
      <ToggleButtonGroupViewType
        labels={[languageContext("ListView"), languageContext("imageview")]}
      />
    </BaseGrid>
  );
};

export default TabFilter;
